import React, { FC, memo } from "react"
import Spin from "../Spin/Spin"
// @ts-ignore
import css from "./LoadingContent.less"
import { SpinSize } from "antd/lib/spin"

type LoadingContentProps = {
    style?: React.CSSProperties
    size?: SpinSize
}

const LoadingContent: FC<LoadingContentProps> = ({ style, size }) => {
    return (
        <div className={css.root} /* style={style} */>
            <Spin size={size} />
        </div>
    )
}

export const LoadingLoggedIn: FC<LoadingContentProps> = () => {
    return <LoadingContent />
}

export default memo(LoadingContent)
